import SuccessPic from '@/ui/assets/success-icon.svg';
import { Button, Heading, Text, Translation } from '@/ui/components';
import cn from 'classnames';
import Image from 'next/image';

import s from './PasswordUpdated.module.css';

type PasswordUpdatedProps = {
  url: string;
};

const PasswordUpdated = ({ url }: PasswordUpdatedProps) => {
  return (
    <article className={cn(s.wrapper)}>
      <Image src={SuccessPic} className={s.picture} alt="Success Image" />
      <Heading spacing="tiny" centerText weight="medium">
        <Translation context="password_updated" token="title" />
      </Heading>
      <Text centerText spacing="semi">
        <Translation context="password_updated" token="description" />
      </Text>
      <Button isFullWidth href={url}>
        <Translation context="password_updated" token="button" />
      </Button>
    </article>
  );
};

export default PasswordUpdated;
